<div class="modal-header border-0 pb-0">
  <button type="button" class="btn-close" mat-dialog-close></button>
</div>

<mat-dialog-content class="mt-3 mb-3">

<div class="col-md-12 text-center">
    
    <div class="preview-wrapper">
        <button mat-icon-button class="nav-arrow left" [disabled]="currentIndex == 0"
            (click)="prevImage()">
            <mat-icon>chevron_left</mat-icon>
        </button>
    
        <img [src]="selectedImage" class="img-fluid preview-img" />
        <button mat-icon-button  class="nav-arrow right" [disabled]="currentIndex == imagenes.length - 1"
            (click)="nextImage()">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>

    <!-- Indicadores -->
    <div class="d-flex justify-content-center gap-2 mt-3">
        <span
          *ngFor="let img of imagenes; let i = index"
          class="indicator"
          [class.active]="i === currentIndex"
          (click)="changeImage(i)">
        </span>
    </div>

</div>

</mat-dialog-content>